import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import type { GameDescriptionFragment } from "@workspace/casino_core/queries/GameQuery";
import { createContext } from "react";
import type StartSessionProps from "./GameContextProvider/useGameContextProvider/useGameSessionProps/StartSessionProps";

type Props = {
  game?: SingleGameFragment;
  gameUrl?: string;
  currencyOptions?: CurrencyOptions;
  description?: GameDescriptionFragment;
  isFunMode: boolean;
  setFunMode: SetState<boolean>;
  isFullScreen: boolean;
  setFullScreen: SetState<boolean>;
  inGameCurrency?: string | null;
  setInGameCurrency: SetState<Maybe<string | null>>;
  inGameCurrencyList?: string[];
  gameSession?: GameSessionFragment;
  hub88Session?: Hub88SessionFragment;
  startSession: (props: StartSessionProps) => unknown;
  closeGameSession: () => unknown;
  loadingSession: boolean;
  options: Record<string, string>;
  setOptions: SetState<Record<string, string>>;
  gameContainerElement?: OriginalGamesViewElement;
  setGameContainerElement: SetState<OriginalGamesViewElement | undefined>;
  isWalletVisibleOnMobile?: boolean;
};

const GameContext = createContext<Props>({
  isFunMode: false,
  setFunMode: (_) => null,
  isFullScreen: false,
  setFullScreen: () => undefined,
  setInGameCurrency: (_) => null,
  startSession: (_) => null,
  closeGameSession: () => undefined,
  loadingSession: false,
  options: {},
  setOptions: (_) => null,
  gameContainerElement: undefined,
  setGameContainerElement: (_) => null,
  currencyOptions: undefined,
  isWalletVisibleOnMobile: false,
});

export default GameContext;
